import { Color } from "../../drawing/Color";

export class TextItemOption {
  constructor(
    public name: string = "",
    public text: string = "",
    public textColor: Color = new Color("#000000"),
    public backgroundColor: Color = new Color("transparent"),
    public isSelected: boolean = false,
    public score: number = 0,
    public code: string = "",
  ) {
  }
}
